import { IconProps } from '@models/icons';

function PrepaidCardIcon({ size = 16, color }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.25 18.0823H9.25H3.75C3.19772 18.0823 2.75 17.6346 2.75 17.0823V12.0823V9.08234C2.75 8.53005 3.19772 8.08234 3.75 8.08234H5.75M5.75 8.08234H11.25H18.75C19.3023 8.08234 19.75 7.63462 19.75 7.08234V5.83234C19.75 4.72777 18.8546 3.83234 17.75 3.83234H6.75C6.19772 3.83234 5.75 4.28005 5.75 4.83234V8.08234ZM19.75 7.08234V12.5823"
                stroke={color} strokeWidth="2"/>
            <path
                d="M16.25 14.1099C16.9039 12.1801 19.4 11.687 20.6923 13.3024C22.3077 15.3216 20.2885 18.1484 16.25 20.1676"
                stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M16.25 14.1098C15.5961 12.18 13.1 11.6868 11.8077 13.3023C10.1923 15.3215 12.2115 18.1483 16.25 20.1676"
                stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

export default PrepaidCardIcon;
